import React from 'react';
import './About.css';
import { FaUser } from 'react-icons/fa';

function About() {
  return (
    <section className="about">
      <h2><FaUser className="section-icon" /> About Me</h2>
      <p>
        I'm an IT professional based in Melbourne, Victoria, with over a decade of experience
        in system administration, software development, and IT consulting. Currently serving as a Specialist
        Technician at the Department of Education and Systems Engineer at JB Hi-Fi Education Solutions.
      </p>
      <p>
        My expertise spans Linux and Windows server administration, embedded systems, web development with
        Laravel and PHP, and designing robust IT infrastructure solutions. I'm passionate about creating
        efficient systems and developing innovative software solutions.
      </p>

      <h3>I also enjoy the following hobbies outside of work</h3>
      <div className="interests-list">
        <span>Hiking</span>
        <span>Board/Tabletop Games</span>
        <span>Classical Music</span>
        <span>Reverse Engineering</span>
        <span>Video Games</span>
        <span>Fencing</span>
        <span>Vintage Computing</span>
        <span>Creative Writing</span>
        <span>Philosophy</span>
      </div>
    </section>
  );
}

export default About;
